import { render } from "./AdminTicketRouting.vue?vue&type=template&id=8d92ddec&scoped=true"
import script from "./AdminTicketRouting.vue?vue&type=script&lang=js"
export * from "./AdminTicketRouting.vue?vue&type=script&lang=js"

import "./AdminTicketRouting.vue?vue&type=style&index=0&id=8d92ddec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d92ddec"]])

export default __exports__